// * Bootstrap libraries
import './_bootstrap';

// * Any other global site-wide JavaScript should be placed below.

(function($) {
    // Mobile nav
    var burger = document.getElementById('burgerBtn');
    var mobileNav = document.getElementById('mobileNav');
    if (burger && mobileNav) {
        burger.addEventListener('click', function () {
            mobileNav.classList.toggle('open');
        });
        mobileNav.querySelectorAll('a').forEach(function (a) {
            a.addEventListener('click', function () { mobileNav.classList.remove('open'); });
        });
    }

    // Scroll to contact (header + hero CTA)
    function scrollToContact() {
        var el = document.getElementById('contact');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    var headerCta = document.getElementById('headerCta');
    var heroCta = document.getElementById('heroCta');
    if (headerCta) headerCta.addEventListener('click', scrollToContact);
    if (heroCta) heroCta.addEventListener('click', scrollToContact);

    // Reveal on scroll
    var revealEls = document.querySelectorAll('[data-reveal]');
    if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) entry.target.classList.add('in');
            });
        }, { threshold: 0.12 });
        revealEls.forEach(function (el) { observer.observe(el); });
    } else {
        revealEls.forEach(function (el) { el.classList.add('in'); });
    }

    // FAQ accordion
    document.querySelectorAll('.faq-item').forEach(function (item) {
        var btn = item.querySelector('.faq-q');
        btn.addEventListener('click', function () {
            item.classList.toggle('open');
        });
    });

    // cookie popup
    const container = document.querySelector(".warning");
    if (document.cookie.indexOf("warning") != -1) {
        container.classList.remove("warning--active");
        container.classList.add("warning--hide");
    }
    if (document.querySelector(".warning")) {
        const apply = container.querySelector(".warning__apply");
        apply.addEventListener("click", () => {
            container.classList.remove("warning--active");
            container.classList.add("warning--hide");
            document.cookie = "warning=true; max-age=2592000; path=/";
        });
    };
    $(document).ready(function() {
        // forms fancy
        $('.fancy-form').fancybox();
    });

})(jQuery);